import { BigNumber, utils } from 'ethers'
import { EarnInfo, TokenInfo } from '~/contracts/useEarnContract'

export const toFloat = (value: BigNumber, decimals: number) =>
	Number.parseFloat(utils.formatUnits(value, decimals))

export const apy = (apr: number) => Math.pow(1 + apr / 365, 365) - 1

export const apr = (
	token: TokenInfo,
	earn: EarnInfo,
	secondsPerBlock: number
) => {
	const reserves1 = toFloat(token.reserves[1], token.decimals) // SIS
	const reserves0 = toFloat(token.reserves[0], token.decimals) // ETH
	const priceSIS = reserves0 / reserves1 // SIS per ETH
	const totalSupply = toFloat(token.totalSupply, token.decimals) // total LP supply

	const priceLP = (reserves0 + reserves1 * priceSIS) / totalSupply
	const rewardPerBlock = toFloat(earn.rewardPerBlock, token.decimals)

	const poolAllocPoint = toFloat(earn.poolInfo.allocPoint, token.decimals)
	const totalAllocPoint = toFloat(earn.totalAllocPoint, token.decimals)
	const balanceOfMaster = toFloat(token.balanceOfMaster, token.decimals)

	const totalPoolETH = priceLP * balanceOfMaster
	return (
		(((rewardPerBlock *
			((86400.0 / secondsPerBlock) * 365) *
			poolAllocPoint) /
			totalAllocPoint) *
			priceSIS) /
		totalPoolETH
	)
}
